export default __webpack_public_path__ + "static/media/2-warranty.eedb4874.svg";